module.exports = __webpack_public_path__ + "media/assets/images/airplus-icon-ebc58e9a48d4eb943c8f00a6e83ee60f.png";